
import store from '@/store';
import { format, utcToZonedTime } from 'date-fns-tz';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { User } from '@/models/main';
import { timeZoneDefault } from '@/utils/PortalConstants';
import * as routeNames from '@/router/routeNames';

@Component({
  components: {},
  computed: {
    ...mapState('moduleUser', { user: 'user', userSelectedDates: 'userSelectedDates' }),
  },
})
export default class DateSelect extends Vue {
  @Prop({ type: Boolean, default: true }) private readonly RangeMsgWarn!: boolean;
  public routeNames = routeNames;
  private menu = false;
  private user!: User;
  private userSelectedDates!: string[];
  private today = '';
  private chosenDate = '';

  private todayClick(): void {
    this.chosenDate = this.today;
  }

  @Watch('menu')
  private onMenuClosed() {
    if (!this.menu) {
      this.$emit('changeDate', this.chosenDate);
    }
  }

  private mounted() {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    this.today = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd'); // today
    if (this.userSelectedDates[0]) {
      this.chosenDate = this.userSelectedDates[0];
    } else {
      this.chosenDate = this.today;
      store.dispatch('moduleUser/setUserDates', [this.today]);
    }
  }
}
